import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

const ThemeCtx = createContext({
  theme: "dark",
  toggleTheme: () => {},
});

export const useTheme = () => useContext(ThemeCtx);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const savedTheme = localStorage.getItem("kk-theme");

      if (savedTheme === "light" || savedTheme === "dark") {
        return savedTheme;
      }

      return "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    const html = document.documentElement;

    // Apply theme to <html>
    html.setAttribute("data-theme", theme);

    // Useful for browser UI
    html.style.colorScheme = theme;

    // Save preference
    try {
      localStorage.setItem("kk-theme", theme);
    } catch {
      // Ignore storage errors
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((currentTheme) =>
      currentTheme === "dark" ? "light" : "dark"
    );
  };

  return (
    <ThemeCtx.Provider
      value={{
        theme,
        toggleTheme,
      }}
    >
      {children}
    </ThemeCtx.Provider>
  );
}

export default ThemeProvider;